export const statusResponseHandler = (status,data) => {
    if(status===500){
        window.location.href = "https://cationscq.com/algoDeuErrado"
    }
    
}